import { useEffect, useMemo } from "react";
import { Loading } from "@gpstrackit/react-controls";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";

//Actions
import {
    loginResult,
    checkLoginUserByCode,
} from 'Redux/actions';

//Styles
import './loginsocialmedia.scss'

const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}

const LoginSocialMediaView = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const history = useNavigate();
    let query = useQuery();

    const errorHandler = (error = messages['login_social_media_error_default']) => {
        history(`/login`);
        let trimError = String(error).trim();
        trimError = trimError.split(messages['login_social_media_error_presignin'])[1] || trimError;
        trimError = trimError.split(messages['login_social_media_error_preauthentication'])[1] || trimError;
        trimError = trimError.replace('.', '');
        if (trimError) {
            dispatch(loginResult(null, false, trimError))
        } else {
            dispatch(loginResult(null, false, error))
        }
    };

    useEffect(() => {

        if (query) {
            let code = query.get("code")
            if (!code) {
                let error_description = query.get('error_description');
                errorHandler(error_description);
            } else {
                dispatch(checkLoginUserByCode(code, history));
            }
        } else {
            errorHandler(messages['login_social_media_error']);
        }
    }, [])

    return (
        <div className="loading-area center-loading-social-media">
            <Loading />
        </div>

    )
}
export default LoginSocialMediaView;